export default __webpack_public_path__ + "static/media/rocks-00.8fe2291f.png";